import React from "react";
import { useHistory } from "react-router";
import { fancyTimeFormat } from "../../utils/fancyTimeFormat";
import { cdnImageUrl } from "../../static/config";
import { LazyLoadImage } from "react-lazy-load-image-component";

const VodItem = ({ item, width }) => {
  const history = useHistory();

  return (
    <div
      key={item.id}
      className="vod-item"
      style={width ? { width: width } : {}}
      onClick={() => {
        history.push(`/voddetail/${item.id}`);
      }}
    >
      <div className="vod-img">
        <LazyLoadImage
          src={`${cdnImageUrl}/${item.videoImage["16_9"]}`}
          style={{ width: "100%", height: "auto" }}
          alt="vod-item"
        />
        <div className="duration">{fancyTimeFormat(item?.length)}</div>
      </div>
      <div className="description" title={item.title}>
        {item.title}
      </div>
    </div>
  );
};

export default VodItem;
